import { APP_INITIALIZER, Provider } from '@angular/core';
import { TranslateLangService } from '@core/bootstrap/translate-lang.service';
import { MaintenanceService } from '@core/bootstrap';

export function TranslateLangServiceFactory(
  translateLangService: TranslateLangService
) {
  return () => translateLangService.load();
}

export function MaintenanceServiceFactory(
  maintenanceService: MaintenanceService
) {
  return () => maintenanceService.load();
}

export const appInitializerProviders: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: TranslateLangServiceFactory,
    deps: [TranslateLangService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: MaintenanceServiceFactory,
    deps: [MaintenanceService],
    multi: true,
  },
];
